module.exports = __webpack_public_path__ + "img/e2m-logo-fb.ef5e8278.png";